module.exports = __webpack_public_path__ + "static/img/shcygn7.75dba93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/shcygn7.png
// module id = 377
// module chunks = 0